import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Make sure to use 'react-router-dom'
import baseUrl, { corporateUrl } from '../../config/config';
import '../../styles/deviceDetails/deviceDetails.css';
import "../../styles/allAssets/allAssets.css"
import { FiEdit3 } from "react-icons/fi";
import { BsTrash } from "react-icons/bs";
import { BsInfoCircle, BsX } from "react-icons/bs";
import icons from '../../data/assetTypes';
import Popupq from '../../components/popupq/PopupQ';
import api from '../../api/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MdSpeaker } from "react-icons/md";
import { Tooltip } from 'react-tooltip';
import { HiOutlineArrowSmLeft } from 'react-icons/hi';
import { BsThreeDotsVertical, BsFileEarmarkPdf } from 'react-icons/bs';
import { FiEye } from 'react-icons/fi';


const AssetDetails = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const { objId, empId } = useParams();
    const [userDetails, setDetails] = useState(null);
    //const [employeeDetails, setEmployeeDetails] = useState(null);
    const [assetDatas, setAssetDatas] = useState(null);
    const [secondaryDetails, setSecondaryDetails] = useState([]);
    const [assetDetailIcon, setAssetDetailIcon] = useState(null);
    const [assetIcons, setAssetIcons] = useState(null);
    const isMounted = useRef(false);
    const [showPopup, setShowPopup] = useState(false);
    const isAdmin = localStorage.getItem("access_type");

    // Attachments state
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [attachmentName, setAttachmentName] = useState('');
    const [attachments, setAttachments] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const event = 'Deleted';
    const id = localStorage.getItem("user_id");

    const [activityData, setActivityData] = useState({
        assetNumber: '',
        employeeId: id,
        event: event,
    });

    // ===== Attachments helpers =====
    const fetchAttachments = async () => {
        try {
            const tokenLocal = localStorage.getItem('token');
            if (!tokenLocal) {
                navigate('/login');
                return;
            }

            const response = await api.get(`${baseUrl}/api/asset-attachments/${objId}`, {
                headers: {
                    'Authorization': `Bearer ${tokenLocal}`,
                },
            });

            if (response && response.data) {
                setAttachments(response.data);
            }
        } catch (err) {
            console.error('Error fetching attachments:', err);
        }
    };

    const handleAttachmentFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) {
            setSelectedFile(null);
            return;
        }

        // Allow only PDF
        if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
            alert('Only PDF files are allowed');
            e.target.value = null;
            setSelectedFile(null);
            return;
        }

        setSelectedFile(file);
    };

    const handleAttachmentUpload = async () => {
        if (!selectedFile) {
            alert('Please choose a PDF file');
            return;
        }
        if (!attachmentName.trim()) {
            alert('Please enter attachment name');
            return;
        }

        try {
            setIsUploading(true);
            const tokenLocal = localStorage.getItem('token');
            if (!tokenLocal) {
                navigate('/login');
                return;
            }

            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('name', attachmentName.trim());
            formData.append('assetId', objId);

            await api.post(`${baseUrl}/api/asset-attachments/upload`, formData, {
                headers: {
                    'Authorization': `Bearer ${tokenLocal}`,
                    'Content-Type': 'multipart/form-data',
                },
            });

            setShowUploadModal(false);
            setSelectedFile(null);
            setAttachmentName('');
            await fetchAttachments();
        } catch (err) {
            console.error('Error uploading attachment:', err);
            alert('Failed to upload attachment');
        } finally {
            setIsUploading(false);
        }
    };

    const handleAttachmentDownload = async (attachmentId, fileName) => {
        try {
            const tokenLocal = localStorage.getItem('token');
            if (!tokenLocal) {
                navigate('/login');
                return;
            }

            const response = await api.get(`${baseUrl}/api/asset-attachments/download/${attachmentId}`, {
                headers: {
                    'Authorization': `Bearer ${tokenLocal}`,
                },
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName || 'attachment.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            console.error('Error downloading attachment:', err);
            alert('Failed to download attachment');
        }
    };
    const handleViewFunction = (objectID, assetNumber) => {
        navigate(`/asset-details/${objectID}/${encodeURIComponent(assetNumber)}`)
        fetchAssetData(objectID)
    }

    useEffect(() => {
        isMounted.current = true;
        fetchAssetData(objId);
        fetchAttachments();
        return () => {
            isMounted.current = false;
        };
    }, [objId]);

    // Close attachment menu when clicking outside
    useEffect(() => {
        const handleClickOutside = () => {
            if (openMenuIndex !== null) {
                setOpenMenuIndex(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [openMenuIndex]);

    const getbscolor = (status) => {
        switch (status) {
            case 'New/Verified':
                return '#ebf2ff';
            case 'In stock':
                return '#f6f0ff';
            case 'Assigned':
                return '#ecfdf3';
            case 'Maintenance':
                return '#fbd5bf';
            case 'Returned':
                return '#fcf3d7';
            case 'Clearance Done':
                return '#ffe9f2';
            case 'To Be Decommissioned':
                return '#fee8e7';
            case 'Lost/Stolen':
                return '#ff9ca5';
            case 'Obsolete':
                return '#ededf0';
            default:
                return {};
        }
    };

    const getcolor = (status) => {
        switch (status) {
            case 'New/Verified':
                return '#76a9ff'
            case 'In stock':
                return '#5c2680'
            case 'Assigned':
                return '#008000'
            case 'Maintenance':
                return '#e4521d'
            case 'Returned':
                return '#f3ae3f'
            case 'Clearance Done':
                return '#ff6eaa'
            case 'To Be Decommissioned':
                return '#c8372d'
            case 'Lost/Stolen':
                return '#811a00'
            case 'Obsolete':
                return '#4a4b57'
            default:
                return {};
        }
    };

    const findassetDetailIcon = (assetType) => {
        const matchingIcon = icons.find(icon => icon['type'] === assetType);
        setAssetDetailIcon(matchingIcon["icon"]);
    }
    const fetchAssetData = async (objId) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                console.log("No token available when calling device data");
                navigate("/login");
            } else {
                const [assetDetailResponse, allAssetsResponse] = await Promise.all([
                    api.get(`${baseUrl}/api/asset-detail/${objId}`, {
                        headers: {
                            "Authorization": `Bearer ${token}`,
                        }
                    }),
                    api.get(`${baseUrl}/api/all-assets-details`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    })
                ]);

                const detailData = assetDetailResponse.data[0];
                if (isMounted.current) {
                    setAssetDatas(detailData);
                    findassetDetailIcon(detailData?.assetType?.assetType);
                    const filtered = allAssetsResponse.data.filter(asset =>
                        asset.assetType?.assetCategory.toLowerCase().includes('secondary') &&
                        asset.assetDetails.parentAsset === detailData.assetDetails.assetNumber
                    );
                    setSecondaryDetails(filtered);

                }
                const allAssetsData = allAssetsResponse.data;
                const iconsMap = {};
                allAssetsData.forEach(asset => {
                    const matchingIcon = icons.find(icon => icon['type'] === asset.assetType?.assetType);
                    if (matchingIcon) {
                        iconsMap[asset.assetType?.assetType] = matchingIcon["icon"];
                    } else {
                        console.warn(`No matching icon found for assetType: ${asset.assetType?.assetType}?.assetType`);
                    }
                });
                setAssetIcons(iconsMap);

            }
        } catch (err) {
            console.error("Error fetching device data:", err);
        }
    };

    const handleUpdate = (objId, assetNumber) => {
        console.log("Asset id", objId)
        navigate(`/update/${encodeURIComponent(assetNumber)}/${objId}`)
    };

    const handleRemoveFunction = async (asset) => {
        const objId = asset.assetDetails._id; // Extract objId from the current asset object
        asset.assetDetails.status = 'In Stock';
        asset.assetDetails.allocatedPersonId = '';
        asset.assetDetails.parentAsset = '';
        asset.assetDetails.fields = [];
        console.log('remove', asset.assetDetails);
        const response = await api.put(`${baseUrl}/api/asset-update/${objId}`, asset.assetDetails, {
            headers: {
                'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
            },
        });
        window.location.reload();
    }

    const renderFieldDetails = (fieldDetails = [], specifications = []) => {
        return fieldDetails.map((field) => {
            const spec = specifications.find((spec) => spec.feildId === field.feildId || spec.fieldId === field.feildId);
            let option;

            if (field.fieldType === "dropdown" && spec) {
                const valueAsNumber = Number(spec.fieldValue);
                option = field.options ? field.options.find((option) => option.value === valueAsNumber) : '';
            }
            return (
                <>
                    <div className='asset_details_row_section' key={field.fieldId}>
                        <div className='asset_details_label'>{field.fieldName}:</div>
                        <div className='asset_details_desc'>{field.fieldType === "dropdown" ? option?.label : spec ? spec.fieldValue : 'N/A'}</div>
                    </div>
                    {isAdmin === '1' && field.feildName?.toLowerCase() === 'windows license' && (
                        <div className='asset_details_row_section' key={field.fieldId}>
                            <div className='asset_details_label'>{field.fieldName}:</div>
                            <div className='asset_details_desc'>{field.fieldType === "dropdown" ? option?.label : spec ? spec.fieldValue : 'N/A'}</div>
                        </div>
                    )}
                </>
            );

        });
    };

    const assetAttachments = (assetDatas?.assetDetails?.attachments || []).filter(att => att.active === true);

    const handleDelete = async (item) => {
        // Show a confirmation dialog for deleting the main asset
        const userConfirmed = window.confirm('Are you sure you want to delete this device entry?');
        if (userConfirmed) {
            try {
                if (!token) {
                    navigate("/login");
                } else {
                    // Delete the main asset
                    await api.delete(`${baseUrl}/api/asset-delete/${item.assetDetails._id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                        },
                    });
                    // Prepare activity details
                    const activityDetails = {};
                    if (item.assetDetails.assetNumber) {
                        activityDetails.assetNumber = item.assetDetails.assetNumber;
                        activityDetails.employeeId = activityData.employeeId;
                        activityDetails.event = activityData.event;
                    }

                    // Add activity
                    await api.post(`${baseUrl}/api/add-activity`, activityDetails, {
                        headers: {
                            'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                        },
                    });

                    // if (item.assetCategory === 'primary' && secondaryDetails) {
                    if (item.assetType.assetCategory === 'primary') {
                        // Ask user if they want to delete all subassets
                        const deleteSubAssetsConfirmed = await new Promise((resolve) => {
                            const resolveFunction = (value) => {
                                resolve(value);
                            };
                            setShowPopup({ visible: true, resolveFunction });
                        });


                        if (deleteSubAssetsConfirmed) {
                            // Delete all subassets
                            for (const asset of secondaryDetails) {
                                if (asset.assetDetails.parentAsset === item.assetDetails.assetNumber) {
                                    await api.delete(`${baseUrl}/api/asset-delete/${asset.assetDetails._id}`, {
                                        headers: {
                                            'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                                        },
                                    });
                                }
                            }
                        } else {
                            // Update subassets to remove the parentAsset reference
                            for (const asset of secondaryDetails) {
                                if (asset.assetDetails.parentAsset === item.assetDetails.assetNumber) {
                                    let newAsset = { ...asset, parentAsset: '' };
                                    await api.post(`${baseUrl}/api/device-update/${asset.assetDetails._id}`, newAsset, {
                                        headers: {
                                            'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                                        },
                                    });
                                }
                            }
                        }
                    }

                    // Navigate to all assets and fetch details
                    navigate(`/all-assets`);
                }
            } catch (error) {
                console.error('Error deleting entry:', error);
                // Optionally, set error status here
                // setDeleteStatus('Error deleting entry');
            }
        } else {
            alert("Error deleting asset");
        }
    };

    return (
        <div className='content-section col-12 col-md-12 col-xl-11 asset-section asset-dashboard'>
            <div className='w-100'>
                <div
                    data-tooltip-id="tool-tip-back-button"
                    data-tooltip-content="Back"
                    className='backBtn'
                    onClick={() => navigate(-1)}
                >
                    <HiOutlineArrowSmLeft className='nxt-prev-icon' />
                </div>
                <Tooltip
                    id="tool-tip-back-button"
                    className="asset-tooltip"
                    border="1px solid #5c2680"
                    place="right"
                />
            </div>

            <div className='container'>
                <div className='asset_detail_main'>
                    <div className='asset_detail_content_section'>
                        <div className='asset_detail_content_container'>
                            <div className='asset_detail_content_container_header'>
                                <div className='device_details_heading'>
                                    <div className='asset-detail-image asset-image'>
                                        {assetDatas?.assetType?.assetType === "Speaker" ? <MdSpeaker /> : <FontAwesomeIcon className="font-icons" icon={assetDetailIcon} />}
                                    </div>
                                    <div className='asset-detail-name-title'>
                                        {assetDatas?.assetDetails?.assetNumber || "Loading..."}
                                        <span className='asset-details-subtitle'>{assetDatas?.assetType?.assetType}</span>
                                    </div>
                                </div>
                                {isAdmin && isAdmin === "1" && (
                                    <>
                                        <div className='device_details_edit' onClick={() => handleUpdate(assetDatas.assetDetails?._id, assetDatas?.assetDetails.assetNumber)}>
                                            <p className='device_details_edit_text'>Edit</p>
                                            <FiEdit3 className="action-icon" />
                                        </div>
                                        <div className='device_details_delete' onClick={() => handleDelete(assetDatas)}>
                                            <p className='device_details_delete_text'>Delete</p>
                                            <BsTrash className="action-icon" />
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className='asset_details_row_group'>
                                <div className='asset_details_row_group_heading'>Asset Details</div>

                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Asset Type:</div>
                                    <div className='asset_details_desc'>{assetDatas?.assetType?.assetType}</div>
                                </div>
                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Category:</div>
                                    <div className='asset_details_desc'>{assetDatas?.assetType?.assetCategory}</div>
                                </div>
                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Purchased Year:</div>
                                    <div className='asset_details_desc'>{assetDatas?.assetDetails?.yearOfPurchase}</div>
                                </div>
                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Asset Number:</div>
                                    <div className='asset_details_desc'>{assetDatas?.assetDetails?.assetNumber}</div>
                                </div>
                                {assetDatas?.assetType?.assetType === 'PC/Desktop' && assetDatas?.assetDetails?.purpose && (
                                    <div className='asset_details_row_section'>
                                        <div className='asset_details_label'>Purpose:</div>
                                        <div className='asset_details_desc'>{assetDatas?.assetDetails?.purpose}</div>
                                    </div>
                                )}
                                <div className='asset_details_row_section'>
                                    <div className={`asset_details_label`}>Status:</div>
                                    <div className='asset-status pb-4'>
                                        <span key={assetDatas?.assetDetails.status} className={assetDatas?.assetDetails.status == 'Assigned' ? 'active' : ''} style={{ backgroundColor: getbscolor(assetDatas?.assetDetails.status), color: getcolor(assetDatas?.assetDetails.status), }}>{assetDatas?.assetDetails.status}</span>
                                    </div>
                                </div>
                            </div>

                            <div className='asset_details_row_group'>
                                <div className='asset_details_row_group_heading'>Allocated Details</div>

                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Employee Id:</div>
                                    <div className='asset_details_desc'>{assetDatas?.allocatedPersonDetails?.employeeId}</div>
                                </div>
                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Allocated Person:</div>
                                    <div className='asset_details_desc'>{assetDatas?.allocatedPersonDetails ? assetDatas?.allocatedPersonDetails?.first_name + ' ' + assetDatas?.allocatedPersonDetails?.last_name : ''}</div>
                                </div>
                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Role:</div>
                                    <div className='asset_details_desc'>{assetDatas?.other_roleDetails?.roleName ? assetDatas?.other_roleDetails?.roleName : assetDatas?.roleDetails?.roleName}</div>
                                </div>
                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Seat Allocation :</div>
                                    <div className='asset_details_desc'>{assetDatas?.allocatedPersonDetails?.seat_allocation}</div>
                                </div>
                            </div>

                            <div className='asset_details_row_group'>
                                <div className='asset_details_row_group_heading'>Asset Specifications</div>
                                {renderFieldDetails(assetDatas?.fieldDetails, assetDatas?.specifications)}
                            </div>

                            <div className='asset_details_row_group'>
                                <div className='asset_details_row_group_heading'>Purchase Details</div>

                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Create Date:</div>
                                    <div className='asset_details_desc'>{new Date(assetDatas?.assetDetails?.createDate).toDateString()}</div>
                                </div>
                                <div className='asset_details_row_section'>
                                    <div className='asset_details_label'>Last Updated Date:</div>
                                    <div className='asset_details_desc'>{new Date(assetDatas?.assetDetails?.updateDate).toDateString()}</div>
                                </div>
                                {isAdmin && isAdmin === '1' ?
                                    (
                                        <div className='asset_details_row_section'>
                                            <div className='asset_details_label'>Remarks:</div>
                                            <div className='asset_details_desc'>{assetDatas?.assetDetails?.remarks}</div>
                                        </div>
                                    ) : ""
                                }
                            </div>

                            {/* Attachments section (view only) */}
                            <div className='asset_details_row_group'>
                                <div className='asset_details_row_group_heading'>
                                    Attachments
                                </div>

                                {assetAttachments && assetAttachments.length > 0 ? (
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                        gap: '16px',
                                        width: '100%',
                                    }}>
                                        {assetAttachments.map((att, index) => {
                                            const uploadDateLabel = att.uploadDate
                                                ? new Date(att.uploadDate).toLocaleDateString('en-US', {
                                                    month: 'short',
                                                    day: 'numeric',
                                                    year: 'numeric'
                                                })
                                                : '';
                                            const typeLabel = att.type || 'PDF';
                                            const hasUrl = !!att.s3Url;

                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        backgroundColor: '#fff',
                                                        borderRadius: '12px',
                                                        border: '1px solid #e8e8e8',
                                                        overflow: 'hidden',
                                                        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
                                                        cursor: 'default',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.boxShadow = 'none';
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                    }}
                                                >
                                                    {/* PDF Preview Area */}
                                                    <div style={{
                                                        backgroundColor: '#f8f8f8',
                                                        height: '140px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderBottom: '1px solid #e8e8e8',
                                                        position: 'relative',
                                                        padding: '12px',
                                                    }}>
                                                        {/* Document Preview */}
                                                        <div style={{
                                                            width: '85%',
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            backgroundColor: '#fff',
                                                            borderRadius: '4px',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                            overflow: 'hidden',
                                                            border: '1px solid #eee',
                                                        }}>
                                                            {/* Document Header */}
                                                            <div style={{
                                                                padding: '10px 12px 8px',
                                                                borderBottom: '1px solid #f0f0f0',
                                                            }}>
                                                                <div style={{
                                                                    height: '8px',
                                                                    backgroundColor: '#333',
                                                                    borderRadius: '2px',
                                                                    width: '55%',
                                                                    marginBottom: '6px',
                                                                }}></div>
                                                                <div style={{
                                                                    height: '4px',
                                                                    backgroundColor: '#ddd',
                                                                    borderRadius: '2px',
                                                                    width: '35%',
                                                                }}></div>
                                                            </div>
                                                            {/* Document Content Lines */}
                                                            <div style={{
                                                                padding: '10px 12px',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '5px',
                                                                flex: 1,
                                                            }}>
                                                                <div style={{ height: '3px', backgroundColor: '#e8e8e8', borderRadius: '2px', width: '100%' }}></div>
                                                                <div style={{ height: '3px', backgroundColor: '#e8e8e8', borderRadius: '2px', width: '95%' }}></div>
                                                                <div style={{ height: '3px', backgroundColor: '#e8e8e8', borderRadius: '2px', width: '88%' }}></div>
                                                                <div style={{ height: '3px', backgroundColor: '#e8e8e8', borderRadius: '2px', width: '92%' }}></div>
                                                                <div style={{ height: '3px', backgroundColor: '#e8e8e8', borderRadius: '2px', width: '75%' }}></div>
                                                                <div style={{ height: '3px', backgroundColor: '#e8e8e8', borderRadius: '2px', width: '85%' }}></div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Card Footer */}
                                                    <div style={{
                                                        padding: '12px 14px',
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        gap: '10px',
                                                    }}>
                                                        {/* PDF Icon */}
                                                        <div style={{
                                                            width: '32px',
                                                            height: '32px',
                                                            borderRadius: '6px',
                                                            backgroundColor: '#f6f0ff',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexShrink: 0,
                                                        }}>
                                                            <BsFileEarmarkPdf style={{
                                                                color: '#5c2680',
                                                                fontSize: '16px'
                                                            }} />
                                                        </div>

                                                        {/* Title and Info */}
                                                        <div style={{
                                                            flex: 1,
                                                            minWidth: 0,
                                                            overflow: 'hidden',
                                                        }}>
                                                            {/* Title - First Row */}
                                                            <div style={{
                                                                fontWeight: 600,
                                                                fontSize: '13px',
                                                                color: '#1a1a1a',
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                marginBottom: '3px',
                                                                lineHeight: '1.3',
                                                            }}>
                                                                {att.name || 'Untitled Document'}
                                                            </div>
                                                            {/* Type - Second Row */}
                                                            <div style={{
                                                                fontSize: '11px',
                                                                color: '#888',
                                                                marginBottom: '2px',
                                                                lineHeight: '1.3',
                                                            }}>
                                                                {typeLabel}
                                                            </div>
                                                            {/* Date - Third Row */}
                                                            <div style={{
                                                                fontSize: '11px',
                                                                color: '#aaa',
                                                                lineHeight: '1.3',
                                                            }}>
                                                                {uploadDateLabel}
                                                            </div>
                                                        </div>

                                                        {/* 3-dot Menu */}
                                                        <div style={{ position: 'relative' }}>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setOpenMenuIndex(openMenuIndex === index ? null : index);
                                                                }}
                                                                style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    padding: '4px',
                                                                    cursor: 'pointer',
                                                                    borderRadius: '4px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    transition: 'background-color 0.15s ease',
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = '#f0f0f0';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                                }}
                                                            >
                                                                <BsThreeDotsVertical style={{
                                                                    color: '#666',
                                                                    fontSize: '14px'
                                                                }} />
                                                            </button>

                                                            {/* Dropdown Menu */}
                                                            {openMenuIndex === index && (
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '100%',
                                                                        right: 0,
                                                                        marginTop: '4px',
                                                                        backgroundColor: '#fff',
                                                                        borderRadius: '8px',
                                                                        boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                                                                        border: '1px solid #e8e8e8',
                                                                        zIndex: 1000,
                                                                        minWidth: '120px',
                                                                        overflow: 'hidden',
                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (hasUrl) {
                                                                                window.open(att.s3Url, '_blank', 'noopener,noreferrer');
                                                                            }
                                                                            setOpenMenuIndex(null);
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            padding: '10px 14px',
                                                                            border: 'none',
                                                                            backgroundColor: 'transparent',
                                                                            cursor: hasUrl ? 'pointer' : 'not-allowed',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '10px',
                                                                            fontSize: '13px',
                                                                            color: hasUrl ? '#333' : '#999',
                                                                            transition: 'background-color 0.15s ease',
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            if (hasUrl) {
                                                                                e.currentTarget.style.backgroundColor = '#f6f0ff';
                                                                            }
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.backgroundColor = 'transparent';
                                                                        }}
                                                                    >
                                                                        <FiEye style={{ fontSize: '14px', color: '#5c2680' }} />
                                                                        <span>View</span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className='asset_details_row_section'>
                                        <div className='asset_details_label'>Attachments:</div>
                                        <div className='asset_details_desc'>No attachments found</div>
                                    </div>
                                )}
                            </div>

                            {assetDatas?.assetType?.assetCategory.toLowerCase() === 'primary' &&
                                secondaryDetails.length > 0 && (
                                    <div className='asset_details_row_group secondary-assets-row-group'>
                                        <div className='asset_details_row_group_heading'>Secondary Assets</div>
                                        <div className='asset_details_row_section_slider'>
                                            {secondaryDetails.length > 0 ? (
                                                secondaryDetails.map((element, index) => (
                                                    <div className='asset-item-main' key={element.assetDetails._id || index}>
                                                        <div className='asset-item h-100'>
                                                            <div className='asset-content-inner  col-12'>
                                                                <div className='asset-innersec'>
                                                                    <div className='asset-item-image-title'>
                                                                        <div className='asset-item-image-inner'>
                                                                            {element?.assetType?.assetType === 'Speaker' ? (
                                                                                <MdSpeaker />
                                                                            ) : (
                                                                                <FontAwesomeIcon
                                                                                    className='font-icons'
                                                                                    icon={assetIcons[element.assetType.assetType]}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className='asset-item-number'>
                                                                            {element.assetDetails.assetNumber}
                                                                        </div>
                                                                    </div>
                                                                    <div className='asset-item-action'>
                                                                        <div className='action-icons'>
                                                                            <BsInfoCircle
                                                                                className='action-icon'
                                                                                onClick={() =>
                                                                                    handleViewFunction(
                                                                                        element.assetDetails._id,
                                                                                        element.assetDetails.assetNumber
                                                                                    )
                                                                                }
                                                                            />
                                                                            {isAdmin && isAdmin === '1' && (
                                                                                <>
                                                                                    <FiEdit3
                                                                                        className='action-icon'
                                                                                        onClick={() =>
                                                                                            handleUpdate(
                                                                                                element.assetDetails._id,
                                                                                                element.assetDetails.assetNumber
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                    <Tooltip
                                                                                        id='tool-tip-remove-sub-asset'
                                                                                        className='asset-tooltip'
                                                                                        border='1px solid #5c2680'
                                                                                    />
                                                                                    <BsX
                                                                                        className='action-icon'
                                                                                        data-tooltip-id='tool-tip-remove-sub-asset'
                                                                                        data-tooltip-content='Remove secondary asset'
                                                                                        onClick={() => handleRemoveFunction(element)}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='asset-item-type'>
                                                                    <span className='asset-label'>Asset Type: </span>
                                                                    <span className='asset-data'>{element.assetType.assetType}</span>
                                                                </div>

                                                                <div className='asset-item-category'>
                                                                    <span className='asset-label'>Category: </span>
                                                                    <span className='asset-data'>{element.assetType.assetCategory}</span>
                                                                </div>

                                                                <div
                                                                    className={
                                                                        element.allocatedPersonDetails
                                                                            ? 'asset-item-allocated d-flex flex-column flex-md-row justify-content-between'
                                                                            : 'asset-item-allocated d-flex justify-content-end'
                                                                    }
                                                                >
                                                                    {element.allocatedPersonDetails && (
                                                                        <div className='asset-allocated-person'>
                                                                            <span className='asset-label'>User: </span>
                                                                            <span className='asset-data'>
                                                                                {element.allocatedPersonDetails.first_name +
                                                                                    ' ' +
                                                                                    assetDatas.allocatedPersonDetails.last_name}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                    <div className='asset-status'>
                                                                        <span
                                                                            className={
                                                                                element.assetDetails.status === 'Assigned'
                                                                                    ? 'active'
                                                                                    : ''
                                                                            }
                                                                        >
                                                                            {element.assetDetails.status}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>No secondary assets found.</div>
                                            )}

                                            {showPopup.visible && (
                                                <Popupq
                                                    message='Are you sure you want to delete these sub-assets?'
                                                    data1='Yes'
                                                    data2='No'
                                                    setShowPopup={() => setShowPopup({ visible: false })}
                                                    resolveFunction={showPopup.resolveFunction}
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssetDetails;
